"use client";

import { useEffect } from "react";

import cn from "classnames";

import { useSettings } from "@/contexts/settingsProvider.context";

/** Affirm marketing / ALA embed. Affirm.js is bootstrapped once from the root layout when `enableAffirm` is on. */
export const Affirm = ({
  type = "product",
  className,
  children,
  productId,
  amount = 0,
  showLearnMore = true,
  ...rest
}: AffirmProps) => {
  const settings = useSettings();
  const enabled = Boolean(settings?.enableAffirm);
  const calculatedAmount = amount * 100;
  const isProduct = type === "product";

  useEffect(() => {
    if (!enabled) return;
    if (!window?.affirm?.ui?.refresh) return;
    window.affirm.ui.refresh();
  }, [calculatedAmount, enabled]);

  if (!enabled) return null;

  return (
    <div
      data-testid="affirm"
      className={cn(className, {
        "affirm-as-low-as": isProduct,
        "affirm-site-modal underline": type === "banner",
      })}
      data-page-type={type}
      data-brand="ADT"
      data-affirm-color="black"
      data-sku={productId}
      data-amount={isProduct ? calculatedAmount : undefined}
      data-learnmore-show={showLearnMore}
      {...rest}>
      {children}
    </div>
  );
};

export type AffirmProps = {
  type?: "product" | "banner";
  amount?: number;
  children?: React.ReactNode;
  className?: string;
  productId?: string;
  showLearnMore?: boolean;
};
